import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/auth/auth.service';
import { Cari } from 'src/model/cari';
import { CariListePage } from 'src/model/cari-liste-page';
import { Lojistik } from 'src/model/lojistik';
import { LojistikKaydetRequest } from 'src/model/lojistik-kaydet-request';
import { Master } from 'src/model/master';
import { Guzergah } from 'src/model/rota';
import { Sube } from 'src/model/sube';
import { RestService } from 'src/providers/rest.service';

declare var $: any;

@Component({
  selector: 'app-rota-olustur',
  templateUrl: './rota-olustur.component.html',
  styleUrls: ['./rota-olustur.component.css']
})
export class RotaOlusturComponent implements OnInit {

  @ViewChild("excelinfo") excelinfo:ElementRef
  @ViewChild("file") fileInput:ElementRef

  id = '0';
  lojistik: Lojistik = new Lojistik();
  secilenCari: Cari;
  cariAraLoading = false;
  cariAraText = '';
  showSearchResultCountCari = 10;
  showSearchResultCountModelCari: number[] = [10, 20, 50, 100];
  showSearchCurrentPageCari = 1;
  showSearchResultTextCari = '';
  searchResultsCari: CariListePage = null;
  subeler: Sube[] = null;
  lokasyonList: Master[] = null;
  urunCinsiList: Master[] = null;
  aracTipiList: Master[] = null;
  baslangicId: number = null;
  varisId: number = null;
  km: number = null;
  urunCinsiId: string = null;
  aracTipiId: number = null;
  fiyat: number = null;
  bosDolu: number = null;
  private subscriptions: Subscription[] = [];

 

  fiyatlamaTuru:number=0;

  constructor(private restService: RestService, private authService: AuthService
    , private route: ActivatedRoute, private toastrService: ToastrService
    , private router: Router) { }


  rotaList: any;
  guzergahType: any;
  guzergahList: any;

  enflasyon:number = 0;
  enflasyonArtis:boolean = true

  currentDate = new Date();
  sonZamlar:any = []
  guncelYakitTarih:string = null
  arananGuncelYakitTarih: string = null

  userGroupId: number = this.authService.getUser().kullaniciGrupId;

  excelInfoText = [
    "Başlangıç Noktası",
    "Başlangıç Noktası Kodu",
    "Bitiş Noktası",
    "Bitiş Noktası Kodu",
    "Km",
    "Stok Kodu",
    "Araç Tipi Kodu",
    "Boş/Dolu",
    "Fiyat",
    "Firma Adı"
  ].join("\n");


  ngOnInit() {

    this.getKullaniciSubeler();
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      this.id = params.id;

      if (!params.id) {
        this.id = '0';
      }

      if (this.id === '0') {
        this.lojistik.subeId = null;
        this.lojistik.cariId = null;
        this.lojistik.tarih = null;
        this.lojistik.mazotBazFiyati = null;
        this.lojistik.aciklama = "";
        this.lojistik.rotalar = [];
      }
      else {
        this.getLojistik().then(()=>{ this.getSonZamlar() });
        this.getRotaList();
        this.getGuzergahList(this.id);
        this.getGuzergahType();

        this.guncelYakitTarih = this.formatDate(new Date(this.currentDate.setDate(this.currentDate.getDate() - 7)));
      }

     
    }));
    this.getMaster();
  
  }

  ngAfterViewInit(){
    $(this.excelinfo.nativeElement).tooltip()
  }

  getSonZamlar() {
    if(this.userGroupId == 1 || this.userGroupId == 5 || this.userGroupId == 6)
    this.arananGuncelYakitTarih = this.guncelYakitTarih
    let mbf = this.lojistik.mazotBazFiyati
    this.restService.getSonZamlar(this.lojistik.mazotBazFiyati,this.guncelYakitTarih).subscribe(res => {
      (res as Array<any>).forEach(element => {
        let f = element.fiyat
        var oran = (100 * Math.abs( ( mbf - f ) / ( ( mbf + f )/2 ) )).toFixed(2)
        let artis = (mbf - f) > 0 ? false : true
        element.degisimOran = [artis ? "+":"-","%",oran].join("")
      });
      debugger;
      this.sonZamlar = res;
    })
  }

  yakitGuncellemeOnay(zam:any){
    let mbf = this.lojistik.mazotBazFiyati
    let f = zam.fiyat
    var oran = (100 * Math.abs( ( mbf - f ) / ( ( mbf + f )/2 ) )).toFixed(2)
    let artis = (mbf - f) > 0 ? false : true
    this.restService.mazotDegisim(zam.id,oran,artis,this.lojistik.cariId).subscribe(res => {
      this.toastrService.success("Yakıt değişikliği başarıyla kaydedildi.");
      this.getLojistik().then(()=>{ this.getSonZamlar() });
      this.getGuzergahList(this.id);
    },err=>{
      this.toastrService.error("Yakıt değişikliği kaydedilemedi.");
    })
  }

  yakitGuncellemeGizle(zam:any){
    this.restService.mazotDegisimGizle(zam.id).subscribe(res => {
      this.toastrService.success("Yakıt değişikliği gizlendi.");
      this.getSonZamlar()
    },err=>{
      this.toastrService.error("Yakıt değişikliği gizlenemedi.");
    })
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  
  formatDate(date:Date = new Date()) {
    return [
      date.getFullYear(),
      this.padTo2Digits(date.getMonth() + 1),
      this.padTo2Digits(date.getDate()),
    ].join('-');
  }

  chooseExcel(){
    this.fileInput.nativeElement.click();
  }

  uploadExcel(){
    var file = this.fileInput.nativeElement.files[0];
    let formData = new FormData();
    formData.append('Dosya', file);
    formData.append("LojistikId",this.id)
    this.restService.ExcelYukle(formData).subscribe(res => {
      this.toastrService.success("Excel yükleme başarıyla tamamlandı.");
      this.getLojistik().then(()=>{ this.getSonZamlar() });
      this.getGuzergahList(this.id);
    },err=>{
      this.toastrService.error("Excel yükleme başarısız oldu.");
    })
    this.fileInput.nativeElement.value = null
  }


  cariAraInputChange() {
    this.showSearchCurrentPageCari = 1;
    this.cariAra();
  }

  showPreviousPageSearchResultsCari() {
    this.showSearchCurrentPageCari--;
    this.cariAra();
  }

  showNextPageSearchResultsCari() {
    this.showSearchCurrentPageCari++;
    this.cariAra();
  }

  cariAra() {
    if (this.showSearchResultCountCari < 1) {
      this.showSearchResultCountCari = 10;
    }
    if (this.showSearchResultCountCari > 20) {
      this.showSearchResultCountCari = 20;
    }
    if (this.cariAraText.length > 3) {
      this.cariAraLoading = true;
      setTimeout(() => {
        this.cariAraLoading = false;
      }, 10000);
      this.searchResultsCari = null;
      this.restService.cariAra(this.cariAraText, this.showSearchCurrentPageCari, this.showSearchResultCountCari).subscribe(res => {
        if (res) {
          this.searchResultsCari = res;
          this.showSearchResultTextCari = this.cariAraText;
        }
        this.cariAraLoading = false;
      });
    }
  }

  getKullaniciSubeler() {
    this.restService.kullaniciSubeleri().subscribe(res => {
      this.subeler = res;
      const subeler = this.authService.getSelectedSubeIdList();
      if (subeler != null && subeler.length === 1 && this.subeler.findIndex(x => x.id === subeler[0]) !== -1) {
        this.lojistik.subeId = subeler[0];
      }
    });
  }

  addCari(c: Cari) {
    this.secilenCari = c;
    this.lojistik.cariId = c.id;
    this.cariAraText = "";
    this.searchResultsCari = null;
  }

  save() {
    debugger;
    if (this.lojistik.cariId === null || this.lojistik.subeId === null || this.lojistik.tarih === null || this.lojistik.mazotBazFiyati === null) {
      this.toastrService.warning("Bilgileri eksiksiz doldurunuz!", "Uyarı!");
      return;
    }

    // if (this.lojistik.rotalar.length === 0) {
    //   this.toastrService.warning("Rota bilgileriniz giriniz!", "Uyarı!");
    //   return;
    // }

    const isNewParam = this.lojistik.id === null ? '1' : '0';
    const request = new LojistikKaydetRequest();

    request.id = this.lojistik.id;
    request.tarih = this.lojistik.tarih;
    request.mazotBazFiyati = this.lojistik.mazotBazFiyati;
    request.aciklama = this.lojistik.aciklama;
    request.cariId = this.lojistik.cariId;
    request.subeId = this.lojistik.subeId;

    request.rotalar = this.lojistik.rotalar;

    this.restService.lojistikKaydet(request).subscribe(res => {
      this.router.navigate(['rota-olusturuldu'], { queryParams: { id: res.id, isNew: isNewParam } });
    });
  }

  removeFromRequestList(rowId: number) {

    $('#cart' + rowId).addClass('target2-highlight');
    setTimeout(() => {
      $('#cart' + rowId).removeClass('target2-highlight');
      this.lojistik.rotalar.splice(rowId, 1);
    }, 1000);
  }

  ekle() {
    debugger;
    if (this.baslangicId === null || this.varisId === null || this.km === null ||
      this.urunCinsiId === null || this.aracTipiId === null || this.fiyat === null) {
      this.toastrService.warning("Bilgileri eksiksiz giriniz!", "Uyarı!");
      return;
    }

    const item = new Guzergah;
    item.baslangicId = this.baslangicId;
    item.varisId = this.varisId;
    item.km = this.km;
    item.stokKodu = this.urunCinsiId;
    item.aracTipiId = this.aracTipiId;
    item.fiyat = this.fiyat;
    item.bosDolu = this.bosDolu;
    item.lojistikId = this.lojistik.id
    item.fiyatlamaTuru = this.fiyatlamaTuru;
    // this.lojistik.rotalar.push(item);
    this.restService.saveGuzergah(item).subscribe(res => {
      if (res) {
        this.toastrService.success("Rota kayıt edildi")
        this.getGuzergahList(this.id);
      } else {
        this.toastrService.success("İşlem başarısız")
      }
    })
  }

  enflasyonGuncelle(){
    this.restService.enflasyonGuncelle(this.lojistik.cariId,this.enflasyon,this.enflasyonArtis)
    .subscribe(res => {
      this.toastrService.success("Enflasyon güncellendi")
      this.getGuzergahList(this.id);
    },err => {
      this.toastrService.error("Enflasyon güncllenirken bir hata oluştu.")
    })
  }

  getMaster() {
    const types = [
      Master.Lokasyon,
      Master.UrunCinsi,
      Master.AracTipi
    ];

    this.restService.getMasterTypes(types).subscribe(res => {
      this.lokasyonList = res?.Lokasyon?.map(x => new Master(x));

      console.log('this.lokasyonList', this.lokasyonList);

      this.urunCinsiList = res?.UrunCinsi?.map(x => new Master(x));
      this.aracTipiList = res?.AracTipi?.map(x => new Master(x));
    });
  }

  getLojistik() {
    return new Promise((resolve)=>{
      this.restService.getLojistik(this.id).subscribe(res => {
        if (res) {
          this.lojistik = res;
          this.secilenCari = res.cari;
          resolve(true);
          console.log(res);
        }
      })
    })
  }

  getRotaList() {
    this.restService.getRotaList(parseInt(this.id)).subscribe(res => {
      this.rotaList = res;
      console.log('this.rotaList', this.rotaList);
    })
  }

  getGuzergahType() {
    this.restService.getGuzergahType().subscribe(res => {
      this.guzergahType = res;
      console.log('this.guzergahType', this.guzergahType);
    })
  }

  getGuzergahList(id: string) {
    this.restService.getGuzergahList(parseInt(id)).subscribe(res => {
      debugger;
      this.guzergahList = res;
    })
  }

  degisimYuzdesi(aktifFiyat: number) {
    let fixedAktif = aktifFiyat.toFixed(2);
    let calc = (this.lojistik.mazotBazFiyati-aktifFiyat)/(aktifFiyat/100);
    // let calc = ((parseFloat(fixedAktif) * 100) / this.lojistik.mazotBazFiyati) - 100;
    // calc = calc*-1;
    let result = (calc >= 0 ? "+%" : "-%") + Math.abs(calc).toFixed(2)
    return result;
  }

  /**
   * 
   * @param fiyat Birim Fiyat
   * @param aktifFiyat AktifMozotFiyat
   * @returns Tutar
   */
  degisimFiyat(fiyat: number, aktifFiyat: number) {
    let fixedAktif = aktifFiyat.toFixed(2);
    let result = 0;
    let calc = (this.lojistik.mazotBazFiyati-aktifFiyat)/(aktifFiyat/100);
    // let calc = ((parseFloat(fixedAktif) * 100) / this.lojistik.mazotBazFiyati) - 100;
    if (Math.abs(calc) >= 5) {
      result = fiyat + (fiyat * ((calc / 100) * 0.45));
    } else {
      result = fiyat;
    }
    return result.toFixed(2);
  }

  guzergahKaldir(id:number){
    debugger;
    this.restService.deleteGuzergah(id).subscribe(res => {
      this.getGuzergahList(this.id)
    })
  }



}
